<script>
export default {
  props: {
    pdfData: {
      type: String,
      default: ''
    },
    pdfDataZoom: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean
    }
  },
  methods: {
    zoom(e) {
      var zoomer = e.currentTarget
      let offsetX, offsetY, x, y
      e.offsetX
        ? (offsetX = e.offsetX)
        : (offsetX = e.touches ? e.touches[0].pageX : 0)
      e.offsetY
        ? (offsetY = e.offsetY)
        : (offsetY = e.touches ? e.touches[0].pageY : 0)
      x = (offsetX / zoomer.offsetWidth) * 100
      y = (offsetY / zoomer.offsetHeight) * 100
      zoomer.style.backgroundPosition = x + '% ' + y + '%'
    }
  }
}
</script>
<template>
  <v-dialog
    :value="show"
    content-class="document-viewer"
    persistent
    :fullscreen="$vuetify.breakpoint.mdAndDown"
    max-width="650"
    @keydown.esc="$emit('onClose')">
    <v-card>
      <DialogBaseColoredTitle color="white">
        <DialogBaseCloseIcon color="primary" @click="$emit('onClose')" />
      </DialogBaseColoredTitle>
      <DialogBaseText class="frame text-center justify-center pa-6">
        <figure
          class="goOnZoom"
          :style="'background-image: url(' + pdfDataZoom + '); '"
          @mousemove="zoom"
          @touchmove="zoom">
          <img :src="pdfData" />
        </figure>
      </DialogBaseText>
      <DialogBaseActions>
        <v-btn color="primary" @click="$emit('onClose')">
          {{$t('button.close')}}</v-btn>
      </DialogBaseActions>
    </v-card>
  </v-dialog>
</template>
<style lang="scss" scoped>
.document-viewer {
  .v-card {
    border-radius: 4px;
    height: 100%;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-positive: 1;
    flex-grow: 1;
    -ms-flex-direction: column;
    flex-direction: column;
  }
  .frame {
    background-color: rgb(50, 54, 57);

    figure {
      margin: 0 auto;

      &.goOnZoom {
        position: relative;
        max-width: 598px;
        overflow: hidden;
        cursor: zoom-in;

        img {
          transition: opacity 0.5s;
          display: block;
          width: 100%;

          &:hover {
            opacity: 0;
          }
        }
      }
    }
  }
}
</style>
